import NicknameLists from '@/shared/publish/MyPublications/NicknameLists'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/publish/MyPublications/NicknameLists/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <NicknameLists />
}
